export const catalog_matrix = [
    {form_key:'responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'alert_id', catalog_key:'alerts'},
    {form_key:'notice_id', catalog_key:'notices'}
]